cockpitApp.directive('connectionCard', function() {
  return {
    restrict: 'E',
    replace: true,
    templateUrl: '/element/sidenav/transfers/connection-card'
  };
});
